import * as React from 'react';
import { Routes, Route } from 'react-router-dom';
import AccreditationBodiesProvider from './context';
import AccreditationBodiesList from './List';
import AccreditationVersions from './Versions';

const AccreditationBodies: React.FC = () => {
  return (
    <AccreditationBodiesProvider>
      <Routes>
        <Route
          path=''
          element={<AccreditationBodiesList />}
        />
        <Route
          path=':id/versions/*'
          element={<AccreditationVersions />}
        />
      </Routes>
    </AccreditationBodiesProvider>
  );
};

export default AccreditationBodies;
